const getYearsList = (fromYear: number) => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: currentYear - fromYear + 1 }, (_, i) => ({
        name: currentYear - i,
        label: currentYear - i,
    }));
};

export default getYearsList;
